<input
  #daterange
  type=""
  ngxDaterangepickerMd
  [lockStartDate]="false"
  [minDate]="minDate"
  [maxDate]='maxDate'
  [disabled]="true"
  [locale]="localdata"
  [timePickerIncrement]="5"
  [alwaysShowCalendars]="dateoptions.alwaysShowCalendars"
  [timePicker24Hour]="true"
  [timePicker]="true"
  [singleDatePicker]="isSingle"
  [placeholder]="placeholder"
  [opens]="opens"
  id="reportdate"
  (change)="customchangeDuration($event)"
  autocomplete="off"
  name="daterange"
  id="daterange"
  class="form-control durationDatePicker"
/>


